/**
 * Custom functionality for What's New page.
 */

/* global $ */

const musts = require('../components/promo-event-news-block');
const press = require('../components/press-mentions');
const instagram = require('../components/instagram-block');

exports.init = function() {
    // Home page initialization.  $ is available here...

	initModule(musts);
	initModule(press);
	initModule(instagram);
};

function initModule(mod) {
	console.log("WHAT'S NEW: initModule(): "+mod);
    if ((mod !== null) && (typeof mod !== 'undefined') && (typeof mod.init === 'function')) {
        mod.init();
    }
}